import { Attr, BelongsTo, Model } from "spraypaint";

import { PLATFORM_LABELS, type SocialPlatform } from "shared/constants/social";
import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type Organisation from "./Organisation";
import { type SocialMetadata } from "./SocialMetadata";

@Model()
class OrganisationSocialIntegration extends ApplicationRecord {
  static jsonapiType = "organisation_social_integrations";

  @Attr({ persist: false }) archived: boolean;

  @Attr() archivedAt: string;

  @Attr({ persist: false }) draftPosts: number;

  @Attr() expiredAt: Nullable<string>;

  @Attr() expiresAt: Nullable<string>;

  @Attr({ persist: false }) fetchingInstagramContent?: boolean;

  @Attr({ persist: false }) fetchingTiktokContent?: boolean;

  @Attr() isOutreachAccount: boolean;

  @Attr() isSocialEngage: boolean;

  @Attr() isSocialListen: boolean;

  @Attr() label: string;

  @Attr() metadata: SocialMetadata;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamIds: number[];

  @Attr() remoteId: string;

  @Attr({ persist: false }) scheduledAt: string;

  @Attr({ persist: false }) scheduledPosts: number;

  @Attr() socialPlatform:
    | "FacebookSocialIntegration"
    | "InstagramSocialIntegration"
    | "LinkedinSocialIntegration"
    | "TiktokSocialIntegration"
    | "TwitterSocialIntegration";

  @Attr() token: string;

  @Attr({ persist: false }) tokenRefreshedAt: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() validUntil: Nullable<string>;

  static notArchived() {
    return this.where({ archivedAt: { eq: "null" } });
  }

  platformIcon(whiteIcon = false) {
    const assetsUrl = String(import.meta.env.VITE_ASSETS_URL);

    if (this.socialPlatform === "TwitterSocialIntegration")
      return `${assetsUrl}/icons/twitter.svg`;

    const format = whiteIcon ? "15x15" : "";

    switch (this.socialPlatform) {
      case "FacebookSocialIntegration":
        return `${assetsUrl}/icons/facebook${format}.svg`;
      case "InstagramSocialIntegration":
        return `${assetsUrl}/icons/instagram${format}.svg`;
      case "LinkedinSocialIntegration":
        return `${assetsUrl}/icons/linkedin${format}.svg`;
      case "TiktokSocialIntegration":
        return `${assetsUrl}/icons/tiktok${format}.svg`;
      default:
        return "";
    }
  }

  platformLabel(): SocialPlatform {
    return PLATFORM_LABELS[this.socialPlatform];
  }
}

export default OrganisationSocialIntegration;
